import type { ReactElement } from 'react';
import { DesignThumbnail } from '@/shared/ui';

export interface QuoteProductPreviewProps {
  /** 상품 대표 사진 서명 주소. 사진이 없으면 null. */
  readonly imageUrl: string | null;
  readonly productName: string;
}

/**
 * 디자인 없는 일반 견적의 미리보기 — 디자인 미리보기와 같은 자리·크기에 상품 사진과 "인쇄 없음"을 보인다.
 * 보여 줄 디자인이 없으므로 [디자인 보기] 는 없다. 사진이 없으면(또는 불러오지 못하면) 견적 요청 폼의 상품 요약처럼 "상품 사진 없음".
 */
export const QuoteProductPreview = ({
  imageUrl,
  productName,
}: QuoteProductPreviewProps): ReactElement => (
  <section aria-label="상품 미리보기" className="flex flex-col gap-4">
    <DesignThumbnail url={imageUrl} alt={`${productName} 상품 사진`} emptyLabel="상품 사진 없음" />
    <p className="border-t border-foreground/10 pt-4 text-sm font-medium">인쇄 없음</p>
  </section>
);
